import axios from 'axios';
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useUserStore = defineStore('hc-member', () => {
    // Refs initialize
    const initialState = {
        env: 'debug',
        auth: null,
        me: {},
        refs: {},
        states: {
            isSubmitting: false,
            isLoading: false,
            isFetching: false,
            isAccountUnlinking: false,
            isAccountLinking: false,
            isAccountLinkFailure: false
        },
        messages: {
            accountLinkFailure: 'LINE 綁定失敗，請稍後再試。',
        },
        lineId: null,
        isLineLinked: false,
    };

    // Refs mapping
    const state = Object.entries(initialState).reduce((acc, [key, value]) => {
        acc[key] = ref(value);
        return acc;
    }, {});

    // Set multiple props
    function setProps(updates) {
        Object.entries(updates).forEach(([key, value]) => {
            if (key in state) {
                state[key].value = value;
            } else {
                console.warn(`未定義的 key: ${key}`);
            }
        });
    }

    // Reset all states
    function reset() {
        Object.entries(initialState).forEach(([key, value]) => {
            state[key].value = value;
        });
    }

    const fetch = async () => {
        // 避免重複讀取
        // if (me.value?.brief?.id) {
        //     return;
        // }
        const url = route('hc.api.member.v3.me')
        try {
            state.states.value.isFetching = true;
            const response = await axios.get(url);
            state.me.value = response.data?.data ?? {};
            return state.me;
        } catch (error) {
            console.error('userStore.fetch', error);
        } finally {
            state.states.value.isFetching = false;
        }
    };

    const lineAccountLink = async (token) => {
        state.states.value.isAccountLinking = true;

        if (!state.me.value?.brief?.id) {
            throw new Error('尚未登入會員');
        }

        try {

            state.states.value.isAccountLinkFailure = false;
            state.messages.value.accountLinkFailure = '';

            const url = route('hc.api.member.v3.line-link-account');
            const params = {
                id: state.me.value?.brief?.id,
                token: token,
            };
            const response = await axios.post(url, params);
            const data = response.data?.data;
            const lineId = data?.lineUserId;
            const isLinked = data?.isLineLinked;
            // me
            state.me.value.metas.is_line_linked = isLinked;
            state.me.value.metas.line_id = lineId;
            // self properties
            state.lineId.value = lineId;
            state.isLineLinked.value = isLinked;
        } catch (error) {
            console.error('userStore.lineAccountLink', error);
            state.states.value.isAccountLinkFailure = true;
            state.messages.value.accountLinkFailure = error.response.data?.message ?? 'LINE 綁定失敗，請稍後再試。';
        } finally {
            state.states.value.isAccountLinking = false;
        }
    };

    return {
        // 擴充所有狀態
        ...state,
        // 設定多個屬性, 重置所有狀態
        setProps, reset,
        // 取得會員資料
        fetch, lineAccountLink,
    };
});
